import { render, staticRenderFns } from "./LottieCtaCardDelete.vue?vue&type=template&id=471f6d70&scoped=true&"
import script from "./LottieCtaCardDelete.vue?vue&type=script&lang=js&"
export * from "./LottieCtaCardDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f6d70",
  null
  
)

export default component.exports